export default __webpack_public_path__ + "static/media/image-soccer-team.18a63d8d.jpg";